import { EnumModel, EnumRecord } from "core/models/enum.model";

export enum OrderStatusEnum {
  WaitingForPayment = 0,
  Payed = 1,
  Accepted = 2,
  Cancelled = 3,
}

export const OrderStatus: EnumRecord<OrderStatusEnum, EnumModel> = {
  [OrderStatusEnum.WaitingForPayment]: { description: "در انتظار پرداخت" },
  [OrderStatusEnum.Payed]: { description: "پرداخت شده" },
  [OrderStatusEnum.Accepted]: { description: "تایید شده" },
  [OrderStatusEnum.Cancelled]: { description: "کنسل شده" },
};
